import type { QueueMode } from "../hooks/useJoinQueue";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

/**
 * Court-queue join panel for the active-session hub.
 *
 * Drop-in exposes a single "Join queue" CTA that calls onJoin("normal").
 * Ranked queues are not part of the drop-in flow.
 *
 * `pending` disables the CTA while a join is in flight to prevent double-submit.
 */
export function JoinQueuePanel({
  onJoin,
  pending,
}: {
  onJoin: (mode: QueueMode) => void;
  pending: boolean;
}) {
  return (
    <Box role="group" aria-label="Join the court queue">
      <Button
        type="button"
        variant="contained"
        onClick={() => onJoin("normal")}
        disabled={pending}
      >
        Join queue
      </Button>
    </Box>
  );
}
